import React from 'react';
import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  width: 100%;
`;

const Card = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  min-width: 150px;
`;

const MetricLoader = styled(ContentLoader)`
  height: 48px;
  width: 140px;
`;

const DataDashboardAnalytics = ({ itemCount = 5 }) => (
  <Wrapper>
    {Array.from({ length: itemCount }).map((_, index) => (
      <Card key={index}>
        <MetricLoader speed={2}>
          <rect x="58" y="0" rx="4" ry="4" width="24" height="24" />

          <rect x="38" y="36" rx="4" ry="4" width="64" height="28" />

          <rect x="10" y="72" rx="4" ry="4" width="120" height="16" />
        </MetricLoader>
      </Card>
    ))}
  </Wrapper>
);

export default DataDashboardAnalytics;
